import { useLayoutEffect, useState } from 'react'
import { If } from 'react-extras'
import { useDispatch, useSelector } from 'react-redux'

import { Button, Checkbox, Input, Select } from 'antd'
import { get } from 'lodash'
import { InputMask } from 'primereact/inputmask'

import { Creators as authActions } from '../../../appRedux/ducks/auth/auth'
import { RULES, validRule } from '../../../constants/Entitlements'
import * as api from '../../../services/api'
import { getMessage } from '../../../util/IntlMessages'
import { isValidCnpj, isValidCpf } from '../../../util/documentValidator'
import { request } from '../../../util/handlerRequestUtil'
import { orderObjects } from '../../../util/orderObjects'
import { PortalLayout } from '../components'
import './Styles.css'

const { Option } = Select

const FarmInformation = (props) => {
  const dispatch = useDispatch()
  const auth = useSelector((selector) => selector.auth.auth)
  const [selectCitiesLoading, setSelectCitiesLoading] = useState(false)
  const [report, setReport] = useState({})
  const [state, setState] = useState({
    selectedCPFButon: '',
    selectedCNPJButon: '',
    formatedCities: [],
    formatedStates: [],
    form: {
      documentNumber: '',
      documentType: 'CPF',
      name: '',
      stateAbbreviation: '',
      cityStateId: '',
      agree: false,
      locationId: ''
    }
  })

  useLayoutEffect(() => {
    const hasAccess = validRule(RULES.FARMER_PORTAL)
    if (!hasAccess) {
      return props.history.push('/farmers/portal')
    }
    listStates()
  }, [])

  useLayoutEffect(() => {
    const receivedReport = get(props, 'location.state.report')

    if (!receivedReport) {
      return props.history.push('/farmers/reports')
    }

    setReport(receivedReport)
  }, [])

  const handleSelectDocumentType = (documentType) => {
    let newState = { ...state }
    newState.form.documentType = documentType
    newState.form.documentNumber = ''
    newState.form.districtId = ''
    newState.form.name = ''
    if (documentType === 'CPF') {
      newState.selectedCPFButon = 'selected-document-type-button'
      newState.selectedCNPJButon = ''
    } else {
      newState.selectedCPFButon = ''
      newState.selectedCNPJButon = 'selected-document-type-button'
    }
    setState(newState)
  }

  const getLocationData = async (documentNumber) => {
    const params = {
      documentType: state.form.documentType,
      documentNumber: documentNumber
    }

    const response = await request(api.getLocationByDocumentNumber({ ...params }), false, true)
    if (response) {
      const stateAbbreviation = get(response, 'cityState.stateAbbreviation', '')
      const cityStateId = get(response, 'cityState.id', '')
      const formattedCities = []
      if (cityStateId !== '') {
        const cityName = get(response, 'cityState.cityName', '')
        const microRegion = get(response, 'cityState.microRegion', '')
        const macroRegion = get(response, 'cityState.macroRegion', '')
        const stateAbbreviation = get(response, 'cityState.stateAbbreviation', '')
        formattedCities.push({
          id: cityStateId,
          description: cityName,
          microRegion,
          macroRegion,
          stateAbbreviation
        })
      }
      setState({
        ...state,
        formatedCities: formattedCities,
        form: {
          ...state.form,
          documentNumber: documentNumber,
          name: response.locationName,
          stateAbbreviation: stateAbbreviation,
          cityStateId: cityStateId,
          locationId: response.id
        }
      })
    }
  }

  async function listStates() {
    try {
      const response = await request(api.listStates({ ignorePagination: true }), true)
      if (response && response.items && response.items.length) {
        const formattedData = response.items.map((item) => {
          return {
            value: item.stateAbbreviation,
            description: `${item.stateName} - ${item.stateAbbreviation}`
          }
        })
        formattedData.sort(orderObjects('description'))
        setState({
          ...state,
          formatedStates: formattedData
        })
      }
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function listCities(params) {
    try {
      const { items = [] } = await request(api.listCities(params), true)
      const formattedData = items.map((item) => {
        return {
          id: item.id,
          description: item.cityName,
          microRegion: item.microRegion,
          macroRegion: item.macroRegion,
          stateAbbreviation: item.stateAbbreviation
        }
      })
      formattedData.sort(orderObjects('description'))
      return formattedData
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function onChangeState(value) {
    if (state.form.stateAbbreviation !== value) {
      setSelectCitiesLoading(true)
      const newFormattedData = {
        ...state.form,
        stateAbbreviation: value,
        cityStateId: getMessage('select')
      }

      const listOfCities = await listCities({
        ignorePagination: true,
        stateAbbreviation: value
      })
      setSelectCitiesLoading(false)
      setState({ ...state, form: newFormattedData, formatedCities: listOfCities })
    }
  }

  async function onChangeCity(value) {
    if (state.form.cityStateId !== value) {
      const newFormattedData = {
        ...state.form,
        cityStateId: value
      }
      setState({ ...state, form: newFormattedData })
    }
  }

  const onChangeDocumentNumber = async (value) => {
    const params = {}
    if (value === '') {
      params.name = ''
      params.districtId = ''
    }
    const isDocumentValid = state.form.documentType === 'CPF' ? isValidCpf(value) : isValidCnpj(value)
    setState({
      ...state,
      form: {
        ...state.form,
        ...params,
        documentNumber: value
      }
    })
    if (isDocumentValid) {
      getLocationData(value)
    }
  }

  const handleSubmit = async () => {
    if (!formIsValid()) {
      return
    }
    const params = {
      ...state.form,
      phoneNumber: auth.phone
    }
    const response = await request(api.userIdentification(params))
    const newAuthData = {
      ...auth,
      customer: response
    }
    dispatch(
      authActions.success({
        ...newAuthData
      })
    )

    const city = state.formatedCities.find((item) => item.id === state.form.cityStateId)

    sessionStorage.setItem('selected_city', JSON.stringify(city))

    if (report.hasForm) {
      return props.history.push({
        pathname: '/farmers/form-report',
        state: { report }
      })
    }

    props.history.push(report.path)
  }

  const formIsValid = () => {
    if (state.form.documentNumber === '') {
      return false
    }
    if (state.form.name === '') {
      return false
    }
    if (state.form.cityStateId === '') {
      return false
    }

    return state.form.agree
  }

  const isValidDocument = (value) => (state.form.documentType === 'CPF' ? isValidCpf(value) : isValidCnpj(value))

  return (
    <PortalLayout>
      <div className="farmer-information">
        <p className="subtitle show-desktop">{getMessage('farminformation-page.sub-title')}</p>
        <div className="wrapper">
          <div className="centered margin-botton-10">
            <label className="label">{getMessage('farminformation-page.select-document-type.label')}</label>
          </div>
          <div className="centered margin-botton-20">
            <div className="form-control">
              <Button
                className={`select-document-type-button ${state.selectedCPFButon}`}
                onClick={() => handleSelectDocumentType('CPF')}
              >
                {getMessage('label.cpf')}
              </Button>
              <Button
                className={`select-document-type-button ${state.selectedCNPJButon}`}
                onClick={() => handleSelectDocumentType('CNPJ')}
              >
                {getMessage('label.cnpj')}
              </Button>
            </div>
          </div>
          <If condition={state.selectedCNPJButon !== '' || state.selectedCPFButon !== ''}>
            <div className="centered margin-botton-20">
              <label className="label">
                {getMessage(`label.insert-${state.form.documentType.toLocaleLowerCase()}`)}
              </label>
              <InputMask
                className="form-input"
                type="text"
                id="document"
                placeholder="Digite aqui"
                value={state.form.documentNumber}
                mask={state.form.documentType === 'CPF' ? '111.111.111-11' : '11.111.111/1111-11'}
                onChange={({ target }) => onChangeDocumentNumber(target.value)}
              ></InputMask>
            </div>
            <If condition={isValidDocument(state.form.documentNumber)}>
              <div className="centered margin-botton-20">
                <label className="label">{getMessage(`label.whats-name`)}</label>
                <Input
                  className="form-input"
                  type="text"
                  id="name"
                  placeholder="Digite aqui"
                  value={state.form.name}
                  onChange={({ target }) => {
                    setState({
                      ...state,
                      form: {
                        ...state.form,
                        name: target.value
                      }
                    })
                  }}
                />
              </div>
              <div className="centered margin-botton-20">
                <label className="label">{getMessage(`selectYourState`)}</label>
                <Select
                  className="form-select"
                  showSearch
                  value={state.form.stateAbbreviation}
                  placeholder={getMessage(`select`)}
                  optionFilterProp="children"
                  onChange={(value) => onChangeState(value)}
                >
                  {state.formatedStates.map((current) => {
                    return (
                      <Option key={current.value} value={current.value}>
                        {current.description}
                      </Option>
                    )
                  })}
                </Select>
              </div>
              <div className="centered margin-botton-20">
                <label className="label">{getMessage(`selectyourCity`)}</label>
                <Select
                  loading={selectCitiesLoading}
                  className="form-select"
                  showSearch
                  value={state.form.cityStateId}
                  placeholder={getMessage(`select`)}
                  onChange={(value) => onChangeCity(value)}
                >
                  {state.formatedCities.map((current) => {
                    return (
                      <Option key={current.id} value={current.id}>
                        {current.description}
                      </Option>
                    )
                  })}
                </Select>
              </div>
              <div className="centered">
                <Checkbox
                  className="checkbox-purple"
                  value={state.form.agree}
                  onChange={(e) => {
                    setState({
                      ...state,
                      form: {
                        ...state.form,
                        agree: e.target.checked
                      }
                    })
                  }}
                >
                  {getMessage('label.agree-terms')} &nbsp;
                  <a href="#" target="_blank" className="link">
                    {getMessage('label.policy-and-terms')}
                  </a>
                </Checkbox>
              </div>
            </If>
          </If>
          <div className="centered ">
            <div className="form-control">
              <Button className={`select-document-type-button back-button`} onClick={() => props.history.goBack()}>
                {getMessage('label.back')}
              </Button>
              <Button
                className={`select-document-type-button ${formIsValid() ? 'forward-button' : 'disabled-button'}`}
                onClick={() => handleSubmit()}
              >
                {getMessage('landing-page.phone-input.submit')}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </PortalLayout>
  )
}

export default FarmInformation
